var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "replace",
    "data-name": "replace",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9009",
    "data-name": "Group 9009",
    transform: "translate(-192.744 -155.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M200.061,173.829a7.277,7.277,0,1,1,7.317-7.277A7.305,7.305,0,0,1,200.061,173.829Zm0-13.619a6.343,6.343,0,1,0,6.376,6.342A6.366,6.366,0,0,0,200.061,160.21Z",
    stroke: "#009ab2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 1.526,
    height: 0.8,
    transform: "translate(196.044 166.152)",
    stroke: "#009ab2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 1.526,
    height: 0.8,
    transform: "translate(199.298 166.152)",
    stroke: "#009ab2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 1.526,
    height: 0.8,
    transform: "translate(202.551 166.152)",
    stroke: "#009ab2",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.089a830f250c2b2f4f6d6a901f310ffc.svg";
export { ForwardRef as ReactComponent };